import { render } from "./SiteHeader.vue?vue&type=template&id=3f61915d"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__